module.exports = __webpack_public_path__ + "static/media/Group 270.f87a061a.svg";